import { FieldDimensionId } from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { GlassWallShapeId, OpeningShapeId } from '@core/constants/Shape';
import {
    IFormInputType,
    IDimensionUnit,
    IFormFieldMaterial,
    IFormFieldDimension,
    IFormFieldShape,
    IFormFieldShapeQuantities,
} from '../../../interfaces/Form';
import {
    allColorsThermoLaquereds,
    allGlasses,
    allMetals,
    allPlastics,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsGlassWallDimension: IFormFieldDimension = {
    [FieldDimensionId.Length]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 1000, max: 6000 },
        required     : true,
        defaultValue : 2500,
    },
    [FieldDimensionId.Height]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 1000, max: 4000 },
        required     : true,
        defaultValue : 2500,
    },
};

export const fieldsGlassWallWindowMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allGlasses,
                ...allPlastics,
            ],
            [
                MaterialId.RecycledPlastic,
                MaterialId.Pvc,
                MaterialId.PvcRigid,
                MaterialId.PolycarbonateOpaque,
                MaterialId.PolycarbonateTeinted,
                MaterialId.PolycarbonateTransparent,
            ],
        ),
        required: true,
    },
};

export const fieldsGlassWallFrameMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allSolidWoods,
                ...allMetals,
                ...allColorsThermoLaquereds,
            ],
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Redcedar,
                MaterialId.Padouk,
                MaterialId.Ipe,
                MaterialId.DriftWood,
                MaterialId.WagonfloorDark,
                MaterialId.WagonfloorLight,
                MaterialId.OakOld,
                MaterialId.Walnut,
                MaterialId.Ash,
                MaterialId.AshOlive,
                MaterialId.Chestnut,
                MaterialId.Acacia,
                MaterialId.Mahogany,
                MaterialId.Elm,
                MaterialId.Alderwood,
                MaterialId.Birch,
                MaterialId.Maple,
                MaterialId.Teak,
                MaterialId.Wenge,
                MaterialId.Cherrywood,
                MaterialId.Ebony,
                MaterialId.Rubber,
                MaterialId.Garapa,
                MaterialId.Aluminum,
                MaterialId.Brass,
                MaterialId.SheetMetal,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
                MaterialId.Poplar,
            ],
        ),
        required: true,
    },
};

export const fieldsGlassWallStyle: IFormFieldShape = {
    value   : undefined,
    options : [
        GlassWallShapeId.TraverseHorizontalGlassWall,
        GlassWallShapeId.TraverseVerticalGlassWall,
        GlassWallShapeId.TraverseCrossedGlassWall,
    ],
    required: true,
};

export const fieldsGlassWallOptions: IFormFieldShapeQuantities = {
    [GlassWallShapeId.SlidingDoorGlassWall]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [GlassWallShapeId.SimpleDoorGlassWall]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [GlassWallShapeId.DoubleDoorGlassWall]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [GlassWallShapeId.SimpleWindowsGlassWall]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [GlassWallShapeId.DoubleWindowsGlassWall]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
};

export const fieldsGlassWallClosingTypes: IFormFieldShape = {
    value   : undefined,
    options : [
        OpeningShapeId.MagnetClosure,
        OpeningShapeId.CremoneClosure,
    ],
    required: true,
};

